import React, {useEffect, useState} from 'react';
import './index.scss';
import {getMediaPath} from "../../../../app/functions";
import desktop_exit from "../../../../assets/icons/login-x-icon.svg";
import {useSelector} from "react-redux";
import Checkbox from "../../../../components/forms/checkbox";
import checkedCheckboxImagePath from "../../../../assets/icons/cb_checked.svg";
import emptyCheckboxImagePath from "../../../../assets/icons/cb_empty.svg";

const WaiverAgreementPopup = (props) => {
    const { payload = {}, handleClose = () => {} } = props;
    const {
        onAccept = () => {},
        message,
        checked = false
    } = payload;

    const [animationClass, setAnimationClass] = useState('');
    const [checkbox, setCheckbox] = useState(checked);
    const Translations = useSelector(store => store.config.Translations);

    useEffect(() => {
        animateIn();
    }, []);

    const animateOut = (callback) => {
        setAnimationClass('')
        setTimeout(() => {
            handleClose();
            typeof callback === 'function' && callback();
        }, 200);
    };

    const animateIn = () => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                setAnimationClass('active');
            })
        })
    };

    const onChangeHandler = (checked) => {
        setCheckbox(checked);
    };

    const onSubmitHandler = () => {
        animateOut(() => {
            if(checkbox) {
                typeof onAccept === 'function' && onAccept();
            }
        });
    };

    return (
        <div className = { "backdrop " + animationClass } onClick = {animateOut}>
            <div className = {"popup_wrapper waiver-agreement-popup-wrapper " + animationClass} onClick = { (e) => e.stopPropagation() }>
                <button className = "x_close_icon"
                        onClick = {animateOut}
                >
                    <img src={getMediaPath(desktop_exit)} alt=''/>
                </button>
                <div className = "popup_content">
                    <div className="text">{ message}</div>
                    <Checkbox
                        id={'waiver_agreement_checkbox'}
                        value={checkbox}
                        label={Translations['waiver_agreement_checkbox_text']}
                        checked_img={checkedCheckboxImagePath}
                        not_checked_img={emptyCheckboxImagePath}
                        onChange={onChangeHandler}
                        className={'waiver-checkbox-wrapper'}
                    />
                    <button
                        className="accept-button"
                        onClick={onSubmitHandler}
                        aria-label={Translations['waiver_agreement_approve']}
                    >
                        {Translations['waiver_agreement_approve']}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WaiverAgreementPopup;